import React from "react";
import { Toast, Icon } from "antd-mobile";
import { post } from "../../../utils/request";
import { href } from "../../../utils/util";

import "./index.less";

class InvitationEvent extends React.Component {
    constructor(...props) {
        super(...props);
        this.state = {};
    }

    render() {
        let { type } = this.state;
        return (
            <div className="InvitationEventBox">
                <div>
                    <div>
                        <h3>活动规则</h3>
                        <p>
                            1、活动对象：被邀请人为首次在远程慧联租车的新客户；
                        </p>
                        <p>
                            2、奖励金额：凡成功邀请司机在远程慧联完成租赁及交车，合同期限一年及以上，每成交一台即可获得税前500元现金奖励，上不封顶；
                        </p>
                        <p>
                            3、发放方式：系统上线前人工审核，合同生效后次月15号前发放；
                        </p>
                        <p>
                            4、以上奖励需扣除20%个人所得税，由我公司代扣代缴；
                        </p>
                        <p>5、以上活动最终解释权归浙江远程慧联有限公司所有。</p>
                    </div>
                    <Icon
                        onClick={() => {
                            this.props.onQuit(false);
                        }}
                        type="cross"
                    />
                </div>
            </div>
        );
    }
}

export default InvitationEvent;



// WEBPACK FOOTER //
// ./src/invitation/modules/InvitationEvent/index.js